// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  height: 178px;
  padding: 2rem;
  text-align: center;
  border: dashed 1px #979797;
  position: relative;
  margin: 0 auto;
}
.container input {
  opacity: 0;
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
}
.container label {
  color: white;
  width: 183px;
  height: 44px;
  border-radius: 21.5px;
  background-color: #2f3164;
  padding: 8px 16px;
}
.container p {
  font-size: 20px;
  font-weight: 600;
  color: #38424c;
  margin-top: 0;
  margin-bottom: 12px;
  height: 20px;
}
.container img {
  padding-top: 10px;
}

.fileover {
  animation: shake 1s;
  animation-iteration-count: infinite;
}

.files-list {
  margin-top: 1.5rem;
}
.files-list .single-file {
  display: flex;
  padding: 0.5rem;
  justify-content: space-between;
  align-items: center;
  border: dashed 1px #979797;
  margin-bottom: 1rem;
}
.files-list .single-file img.delete {
  margin-left: 0.5rem;
  cursor: pointer;
  align-self: flex-end;
}
.files-list .single-file {
  display: flex;
  flex-grow: 1;
}
.files-list .single-file .name {
  font-size: 14px;
  font-weight: 500;
  color: #353f4a;
  margin: 0;
}
.files-list .single-file .size {
  font-size: 12px;
  font-weight: 500;
  color: #a4a4a4;
  margin: 0;
  margin-bottom: 0.25rem;
}
.files-list .single-file .info {
  width: 100%;
}

/* Shake animation */
@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/document-upload/document-upload-drag-and-drop/document-upload-drag-and-drop.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;AACF;AACE;EACE,UAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;AACJ;AAEE;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,iBAAA;AAAJ;AAGE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AADJ;AAIE;EACE,iBAAA;AAFJ;;AAMA;EACE,mBAAA;EACA,mCAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;AAKE;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;AAHJ;AAKI;EACE,mBAAA;EACA,eAAA;EACA,oBAAA;AAHN;AARE;EAeE,aAAA;EACA,YAAA;AAJJ;AAMI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAJN;AAOI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;AALN;AAQI;EACE,WAAA;AANN;;AAWA,oBAAA;AACA;EACE;IACE,2CAAA;EARF;EAWA;IACE,8CAAA;EATF;EAYA;IACE,4CAAA;EAVF;EAaA;IACE,2CAAA;EAXF;EAcA;IACE,4CAAA;EAZF;EAeA;IACE,6CAAA;EAbF;EAgBA;IACE,4CAAA;EAdF;EAiBA;IACE,4CAAA;EAfF;EAkBA;IACE,6CAAA;EAhBF;EAmBA;IACE,2CAAA;EAjBF;EAoBA;IACE,6CAAA;EAlBF;AACF","sourcesContent":[".container {\r\n  height: 178px;\r\n  padding: 2rem;\r\n  text-align: center;\r\n  border: dashed 1px #979797;\r\n  position: relative;\r\n  margin: 0 auto;\r\n\r\n  input {\r\n    opacity: 0;\r\n    position: absolute;\r\n    z-index: 2;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    cursor: pointer;\r\n  }\r\n\r\n  label {\r\n    color: white;\r\n    width: 183px;\r\n    height: 44px;\r\n    border-radius: 21.5px;\r\n    background-color: #2f3164;\r\n    padding: 8px 16px;\r\n  }\r\n\r\n  p {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    color: #38424c;\r\n    margin-top: 0;\r\n    margin-bottom: 12px;\r\n    height: 20px;\r\n  }\r\n\r\n  img {\r\n    padding-top: 10px;\r\n  }\r\n}\r\n\r\n.fileover {\r\n  animation: shake 1s;\r\n  animation-iteration-count: infinite;\r\n}\r\n\r\n.files-list {\r\n  margin-top: 1.5rem;\r\n\r\n  .single-file {\r\n    display: flex;\r\n    padding: 0.5rem;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border: dashed 1px #979797;\r\n    margin-bottom: 1rem;\r\n\r\n    img.delete {\r\n      margin-left: 0.5rem;\r\n      cursor: pointer;\r\n      align-self: flex-end;\r\n    }\r\n\r\n\r\n    display: flex;\r\n    flex-grow: 1;\r\n\r\n    .name {\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      color: #353f4a;\r\n      margin: 0;\r\n    }\r\n\r\n    .size {\r\n      font-size: 12px;\r\n      font-weight: 500;\r\n      color: #a4a4a4;\r\n      margin: 0;\r\n      margin-bottom: 0.25rem;\r\n    }\r\n\r\n    .info {\r\n      width: 100%\r\n    }\r\n  }\r\n}\r\n\r\n/* Shake animation */\r\n@keyframes shake {\r\n  0% {\r\n    transform: translate(1px, 1px) rotate(0deg);\r\n  }\r\n\r\n  10% {\r\n    transform: translate(-1px, -2px) rotate(-1deg);\r\n  }\r\n\r\n  20% {\r\n    transform: translate(-3px, 0px) rotate(1deg);\r\n  }\r\n\r\n  30% {\r\n    transform: translate(3px, 2px) rotate(0deg);\r\n  }\r\n\r\n  40% {\r\n    transform: translate(1px, -1px) rotate(1deg);\r\n  }\r\n\r\n  50% {\r\n    transform: translate(-1px, 2px) rotate(-1deg);\r\n  }\r\n\r\n  60% {\r\n    transform: translate(-3px, 1px) rotate(0deg);\r\n  }\r\n\r\n  70% {\r\n    transform: translate(3px, 1px) rotate(-1deg);\r\n  }\r\n\r\n  80% {\r\n    transform: translate(-1px, -1px) rotate(1deg);\r\n  }\r\n\r\n  90% {\r\n    transform: translate(1px, 2px) rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: translate(1px, -2px) rotate(-1deg);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
